const applyDiscountToCart = async (checkoutId, discountCode) => {
    //console.log('Apply discount', checkoutId, discountCode)

    const query = `query ($checkoutId: ID!) {
            cart(id: $checkoutId) {
                discountCodes {
                  applicable
                  code
                }
            }
        }
    `;

    const queryVariables = {
        checkoutId: 'gid://shopify/Cart/'+checkoutId,
    };

    try {
        const response = await fetch(`https://mysheepi.myshopify.com/api/2024-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': 'd66d74bd7e9b225d81abdb5f7859d2a7',
            },
            body: JSON.stringify({query: query, variables: queryVariables}),
        });

        const result = await response.json();

        //console.log('current discount codes', result.data);
        if (result.data && result.data.cart && result.data.cart.discountCodes && result.data.cart.discountCodes.map(i => i.code).join(',') !== discountCode.split('|').filter(i => i.trim()).join(',')) {
            const mutation = `
    mutation updateDiscountCode($checkoutId: ID!, $discountCode: [String!]) {
      cartDiscountCodesUpdate(
        cartId: $checkoutId,
        discountCodes: $discountCode
      ) {
        cart {
          discountCodes {
            applicable
            code
          }
          discountAllocations {
            targetType
          }
        }
        userErrors {
          code
          field
          message
        }
      }
    }
    `;

            const variables = {
                checkoutId: 'gid://shopify/Cart/' + checkoutId,
                discountCode: discountCode.split('|').filter(i => i.trim()),
            };

            try {
                const response = await fetch(`https://mysheepi.myshopify.com/api/2024-07/graphql.json`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': 'd66d74bd7e9b225d81abdb5f7859d2a7',
                    },
                    body: JSON.stringify({query: mutation, variables}),
                });

                const result = await response.json();
                //console.log('Discount Apply Result:', result.data);

                publish(PUB_SUB_EVENTS.cartUpdate, {source: 'discount-code-application'});
            } catch (error) {
                console.error('Error applying discount code:', error);
            }
        }
    }
    catch(e) {
        //console.log('Discount applier error',e);
    }

};

const applyFrontendDiscounts = () => {
    if (!sessionStorage.getItem('dcode') || !sessionStorage.getItem('dcode-config')) {
        return;
    }
    //console.log('Apply frontend discounts');

    let resp = JSON.parse(sessionStorage.getItem('dcode-config'));
    if (resp) {
        for (let i in resp.data.relatedProducts) {
            let variantInfo = resp.data.relatedProducts[i];
            // extract product id from variantInfo.id with form gid://shopify/ProductVariant/45312544440584
            let variantInfoId = variantInfo.id.split('/').pop();

            document.querySelectorAll('[data-discount-controller-target="price"][data-discount-controller-variant="' + variantInfoId + '"]').forEach(item => {
                if (item.closest('.price') && item.closest('.price.price--on-sale') === null) {
                    item.closest('.price').classList.add('price--on-sale');
                }
                item.innerHTML = variantInfo.price;
            })
            document.querySelectorAll('[data-discount-controller-target="discount-perc"][data-discount-controller-variant="' + variantInfoId + '"]').forEach(item => {
                if (item.closest('.u-product-card') && item.closest('.u-product-card.u-product-card--on-sale') === null) {
                    item.closest('.u-product-card').classList.add('u-product-card--on-sale');
                }

                item.innerHTML = Math.round(variantInfo.discountPerc * 100);
            })
        }
    }
}


const checkCartDiscount = () => {
    let dcode = sessionStorage.getItem('dcode');
    fetch('/cart.js')
        .then(res => res.json())
        .then(data => {
            let cartToken = data.token;
            //console.log('Discount applied cart', data);
            applyDiscountToCart(cartToken, dcode);
        })
}


// if url have attribute dcode read it and remove from url box
const discountController = () => {
    try {
        applyFrontendDiscounts();
    } catch (e) {
        //console.log('Discount applier error', e);
    }

    const url = new URL(window.location);
    if (url.searchParams.has('dcode') || sessionStorage.getItem('dcode')) {
        const dcode = url.searchParams.get('dcode') ?? sessionStorage.getItem('dcode');
        if (dcode) {
            url.searchParams.delete('dcode');
            window.history.replaceState({}, '', url.toString());
            sessionStorage.setItem('dcode', dcode);

            //console.log('dcode applied', dcode);

            fetch('https://backend-services.mysheepi.io/api/validate-discount-coupon?code=' + dcode, {
                method: 'POST',
            }).then(resp => {
                if (resp.status !== 200) {
                    sessionStorage.removeItem('dcode');
                    return new Promise(() => {
                    });
                } else {
                    return resp.json();
                }
            }).then(resp => {
                if (!resp) {
                    sessionStorage.removeItem('dcode');
                    sessionStorage.removeItem('dcode-config');
                } else {
                    sessionStorage.setItem('dcode-config', JSON.stringify(resp));
                    if (resp.data.code) {
                        sessionStorage.setItem('dcode', resp.data.code.join('|'));
                    }
                    applyFrontendDiscounts();
                }
                checkCartDiscount();
            })

        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        let pubSubListener = (event) => {
            console.log('pub sub listener listener triggered', sessionStorage.getItem('dcode'))
            //console.log('Discount cartUpdate', event);
            if (sessionStorage.getItem('dcode')) {
                checkCartDiscount();

                let updatePriceTimer = setInterval(() => applyFrontendDiscounts(), 100);
                setTimeout(() => {
                    clearInterval(updatePriceTimer)
                }, 5000);
            }
        };
        subscribe(PUB_SUB_EVENTS.cartUpdate, pubSubListener);
        subscribe(PUB_SUB_EVENTS.quickAddModalOpened, pubSubListener);
        subscribe(PUB_SUB_EVENTS.variantChange, pubSubListener);
    });


    window.addEventListener('urlUpdate', () => {
        applyFrontendDiscounts();
        let updatePriceTimer = setInterval(() => applyFrontendDiscounts(), 100);
        setTimeout(() => {
            clearInterval(updatePriceTimer)
        }, 1000);
    })
};

discountController();
